var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79515 17.4993C8.38276 18.018 9.15463 18.3327 10 18.3327C10.8454 18.3327 11.6172 18.018 12.2049 17.4993M15 6.66602C15 5.33993 14.4732 4.06816 13.5355 3.13048C12.5979 2.1928 11.3261 1.66602 10 1.66602C8.67392 1.66602 7.40215 2.1928 6.46447 3.13048C5.52678 4.06816 5 5.33993 5 6.66602C5 9.24117 4.35039 11.0043 3.62472 12.1705C3.0126 13.1542 2.70655 13.6461 2.71777 13.7833C2.7302 13.9352 2.76238 13.9932 2.88481 14.084C2.99538 14.166 3.49382 14.166 4.49071 14.166H15.5093C16.5062 14.166 17.0046 14.166 17.1152 14.084C17.2376 13.9932 17.2698 13.9352 17.2822 13.7833C17.2935 13.6461 16.9874 13.1542 16.3753 12.1705C15.6496 11.0043 15 9.24117 15 6.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b8eb11072ece0d91e40cb7c771779961.svg";
export { ForwardRef as ReactComponent };